import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAgiCixboc-9UOSYqNsPv3v08XJqNMFS30",
  authDomain: "vardhamaan-b6d1d.firebaseapp.com",
  projectId: "vardhamaan-b6d1d",
  storageBucket: "vardhamaan-b6d1d.firebasestorage.app",
  messagingSenderId: "522971325597",
  appId: "1:522971325597:web:cc536a7ed84c79987ca074",
  measurementId: "G-8EDRZ3NFGN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export default app;

